// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MoqLh","col":"styles_col__1NsYF"};